import React, { Component } from 'react'
import styled from 'react-emotion'
import { colors } from '../../styles'

const Container = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 30001;
  background-color: rgba(0, 0, 0, .8);
`
const ModalContent = styled('div')`
  padding: 20px;
  padding: ${props => props.padding || '20px'};
  position: fixed;
  border-radius: 5px;
  background: ${colors.tui_white};
  width: ${props => props.width || "80%"};
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;

  @media (max-width: 767px) {    
    max-width: 96%;
    padding: ${props => props.padding || '10px'};      
  }
`

export default class ModalContainer extends Component {

  componentDidMount() {
    document.body.classList.add('x-tui-modal')
  }

  componentWillUnmount() {
    document.body.classList.remove('x-tui-modal')
  }

  render() {
    const { width, padding, children } = this.props

    return (
      <Container>
        <ModalContent width={width} padding={padding}>
          {children}
        </ModalContent>
      </Container>
    )
  }
}
